export const AffiliatedAssociations: string[] = [
  'Indian Society of Pedodontics and Preventive Dentistry',
  'Indian Academy of Pediatrics, Tamil Nadu',
  'Indian Orthodontic Society',
  'GPA Kerala',
  'ASI Punjab',
  'ASI, Rajasthan',
  'ASI, Jharkhand',
  'Homoeopathic Medical Association of India',
  'Indian Academy of Pediatrics, Delhi',
  'Indian Associations of Physiotherapists',
  'Delhi Ophthalmological Society',
  'Delhi Chapter - Associations of Physicians of India',
  'Association of Otolaryngologists of India, Mumbai',
  'IPS (Psychiatric), National',
  'Others',
];
